module.exports = __webpack_public_path__ + "img/coloured-card-with-btn.c913d1fb.jpg";